/* global axios */
import ApiClient from './ApiClient';
import { requestConfig, resourcePath } from './lais/httpHelpers';

class LaisDisparosAPI extends ApiClient {
  constructor() {
    super('lais_disparos', { accountScoped: true });
  }

  create(payload) {
    return axios.post(this.url, payload, requestConfig());
  }

  preview(payload) {
    return axios.post(
      resourcePath(this.url, 'preview'),
      payload,
      requestConfig()
    );
  }

  validate(id) {
    return axios.post(
      resourcePath(this.url, id, 'validate'),
      {},
      requestConfig()
    );
  }

  approve(id, payload = {}) {
    return axios.post(
      resourcePath(this.url, id, 'approve'),
      payload,
      requestConfig()
    );
  }

  reject(id, payload = {}) {
    return axios.post(
      resourcePath(this.url, id, 'reject'),
      payload,
      requestConfig()
    );
  }

  requestChanges(id, payload = {}) {
    return axios.post(
      resourcePath(this.url, id, 'request_changes'),
      payload,
      requestConfig()
    );
  }
}

export default new LaisDisparosAPI();
